module.exports = __webpack_public_path__ + "static/media/update.c49a0e2e.svg";